module.exports = __webpack_public_path__ + "media/images/admin/icons/share-2-709c4a04c43066332bd70478c6a18f38.svg";